<!------------ START TEMPLATE ------------>
<template>
  <div
    slot="header"
    class="flex flex-wrap items-center flex-grow justify-between"
  >
    <!------------ END ADD NOVO Perfil ------------>

    <!------------ START ITENS POR PÁGINA ------------>
    <vx-card class="mt-5 card">
      <div class="flex flex-wrap items-center">
        <!------------ START  MENU DE AÇÕES ------------>
        <vs-dropdown vs-trigger-click class="cursor-pointer mr-4 mb-4">
          <div
            class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32"
          >
            <span class="mr-2">Ações</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>

          <vs-dropdown-menu>
            <vs-dropdown-item @click="imprimir">
              <span>Imprimir</span>
            </vs-dropdown-item>
            <vs-dropdown-item
              v-if="$can($actionsDefault.Exportar, subjectPermission)"
            >
              <span>
                <downloadexcel
                  :data="selected"
                  :fields="colunas"
                  name="perfis.xls"
                  type="xls"
                  >Exportar</downloadexcel
                >
              </span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
        <!------------ END MENU DE AÇÕES ------------>
        <!-- <vs-dropdown vs-trigger-click class="cursor-pointer mr-4 mb-4">
            <div
              class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium"
            >
              <span class="mr-2">Filtrar por: {{ ultimoFiltro }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item @click="filtrar('Ativos')">
                <span>Ativos</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="filtrar('Inativos')">
                <span>Inativos</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="filtrar('Todos')">
                <span>Todos</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown> -->

        <!------------ START ADD NOVO Perfil ------------>
        <div
          class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
          @click="opemModalInsertEdit({})"
          v-if="idEmpresa == 4"
        >
          <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
          <span class="ml-2 text-base text-primary">Fazer transação</span>
        </div>

        <div
          v-if="contaCorrenteTransacoes.length > 0"
          class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
          @click="openModalSaque('Novo')"
        >
          <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
          <span class="ml-2 text-base text-primary">Solicitar novo saque</span>
        </div>

        <div
          v-if="saques.length > 0 && contaCorrenteTransacoes.length > 0"
          class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
          @click="openModalMeusSaques('MeusSaques')"
        >
          <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
          <span class="ml-2 text-base text-primary">Meus saques</span>
        </div>
      </div>

      <table class="table tabela table-bordered">
        <tr>
          <th class="uppercase">Data</th>
          <th class="uppercase">Lançamento</th>
          <th class="uppercase">Protocolo Saque</th>
          <th class="uppercase">Crédito</th>
          <th class="uppercase">Debito</th>
        </tr>
        <tr v-for="item in contaCorrenteTransacoes" :key="item.idTransacao">
          <td>{{ formataDataUTCAux(item.dataTransacao) }}</td>
          <td>{{ item.descricao }}</td>
          <td style="display: flex; justify-content: center">
            <vs-button
              v-if="item.idSaque"
              type="flat"
              v-tooltip="'Abrir Saque'"
              style="
                display: flex;
                width: 100%;
                max-height: 20px;
                justify-content: center;
                color: #626262;
                align-items: center;
              "
              @click="openModalMeusSaques('MeusSaques', item.idSaque)"
              >{{ item.idSaque }}
            </vs-button>
          </td>
          <td style="color: #4848f2">
            <div v-if="item.valorCredito" class="flex justify-end">
              {{ item.valorCredito | currency }}
            </div>
          </td>
          <td style="color: #f92a2a">
            <div v-if="item.valorDebito" class="flex justify-end">
              {{ item.valorDebito | currency }}
            </div>
          </td>
        </tr>
      </table>
      <div class="p-3" style="display: flex; justify-content: end">
        <h5>Saldo :</h5>
        {{ saldo | currency }}
      </div>
    </vx-card>
    <!------------ START INFORMAÇÕES DO Perfil ------------>
    <ModalInfo
      :modalSelecionado="modalSelecionado"
      :popupActive="popupActive"
      :title="`Dados do ${entidade}`"
      @close="popupActive = false"
    ></ModalInfo>

    <vs-popup
      class="holamundo"
      :title="titleSideBar"
      :active.sync="modalForm"
      @close="closeModais"
    >
    </vs-popup>

    <vs-popup
      :title="'Iniciar nova transação'"
      :active.sync="modalTransacao"
      @close="modalTransacao = false"
      class="popupMaior"
    >
      <div v-if="modalTransacao">
        <div class="con-exemple-prompt">
          <div class="vx-row mb-4">
            <span class="textoModal vx-col w-full mb-3"
              >Selecione o Tipo de Transacao:</span
            >
            <div
              v-for="item in formaDeTransacao"
              :key="item.id"
              class="vx-col w-full mb-3"
            >
              <vs-checkbox
                switch
                @change="alterarSomente1(item)"
                class="mt-2"
                v-model="item.selecionado"
              >
                {{ item.text }}
              </vs-checkbox>
            </div>
          </div>
          <div class="mt-4 mb-3">
            <p class="textoModal">Informe o valor:</p>
            <money
              class="w-full vs-inputx vs-input--input normal mt-2"
              name="Valor Transação"
              id="Valor Transação"
              style="width: 100%"
              v-model="formTransacao.valor"
              v-validate="{ required: true, min_value: 0.01 }"
            ></money>
          </div>

          <vs-alert
            v-if="$validator.errors.all().length > 0"
            color="danger"
            title="Atenção!!"
            active="true"
            class="my-3"
            style="height: auto !important"
          >
            <ul>
              <li
                class="mb-2"
                v-for="error in $validator.errors.all()"
                :key="error.id"
              >
                {{ error }}
              </li>
            </ul>
          </vs-alert>
          <center>
            <vs-button
              @click="iniciarTransacao()"
              color="success"
              class="mb-12 mt-12 btn-block"
            >
              <span>Fazer transação</span>
            </vs-button>
            <div class="mt-12 mb-12">
              <br />
              <br />
            </div>
          </center>
        </div>
      </div>
    </vs-popup>

    <div>
      <vs-popup
        class="holamundo financeiro"
        :title="titleSideBar"
        :active.sync="abrirModalSaque"
        @close="fecharModalSaque"
      >
        <div>
          <FormSaque
            @close="fecharModalSaque"
            v-if="abrirModalSaque"
            :dados="dadosSaque"
            :saldo="saldo"
          ></FormSaque>
        </div>
      </vs-popup>
    </div>

    <vs-popup
      class="holamundo"
      :title="'Confirme os Dados'"
      :active.sync="popupContaNova"
      width="550px"
      name="popup"
      not-center
    >
      <div class="con-content">
        <p>
          Para solicitar um saque no nosso sistema, É necessário ter uma conta
          bancária ativa e vinculada, Precisamos da sua confirmação para
          prosseguir.
        </p>
      </div>

      <template>
        <div class="con-footer mt-3 flex justify-end">
          <vs-button
            class="mr-3"
            color="warning"
            type="border"
            @click="popupContaNova = false"
          >
            Cancelar
          </vs-button>
          <vs-button
            color="success"
            type="gradient"
            @click="openModalSaque('Novo', (contaBancariaCriada = true))"
          >
            Concordo
          </vs-button>
        </div>
      </template>
    </vs-popup>

    <vs-popup
      class="holamundo"
      :title="titleSideBar"
      :active.sync="abrirModalContaBancaria"
      @close="fecharModal()"
    >
      <formContaBancariaUsuario
        v-if="contaBancaria"
        :dados="formSaque"
        :dadosContaBancaria="contaBancaria"
        :modal="abrirModalContaBancaria"
        @close="fecharModal()"
      >
      </formContaBancariaUsuario>
    </vs-popup>

    <!------------ END INFORMAÇÕES DO Perfil ------------>
  </div>
</template>
<!------------ START TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import service from '../../services';
import downloadexcel from 'vue-json-excel';
import ModalInfo from '../../components/ModalInfo';
import moment from 'moment';
import jwt from 'jsonwebtoken';
import VxCard from '../../components/vx-card/VxCard.vue';
import { Money } from 'v-money';
import FormSaque from '../forms/FormSaque.vue';
import formContaBancariaUsuario from '../forms/formContaBancariaUsuario.vue';
import { decryptData } from '../../services/decryptData';

export default {
  components: {
    downloadexcel,
    ModalInfo,
    VxCard,
    FormSaque,
    formContaBancariaUsuario,
    Money,
  },
  directives: {},
  props: ['subjectPermission', 'realizarFiltro', 'finalizarFiltro', 'filtro'],
  watch: {
    realizarFiltro: function (newValue) {
      if (newValue == true) {
        this.buscaDados();
        this.$emit('finalizarFiltro', true);
      }
    },
  },
  data() {
    return {
      modalForm: false,
      dadosSideBar: {},
      controllerGeral: 'Extrato',
      formSideBar: 'Extrato',
      entidade: 'Extrato',
      titleSideBar: 'Saque',
      popupActive: false,
      modalSelecionado: [],
      selected: [],
      itens: [],
      itensFiltred: [],
      colunas: {},
      itemsPerPage: 10,
      idEmpresa: null,
      isMounted: false,
      ultimoFiltro: 'Ativos',
      addNewDataSidebar: false,
      idUsuario: null,
      currency: 'R$',
      contaCorrenteTransacoes: [],
      modalTransacao: false,
      tiposDeTransacoes: [],
      saques: [],
      popupContaNova: false,
      contaBancariaCriada: false,
      formaDeTransacao: [
        { id: 1, text: 'Débito' },
        { id: 2, text: 'Crédito' },
      ],
      formTransacao: {
        valor: 0,
        formAplicacao: null,
        tipoTransacao: null,
        idUsuario: null,
        tipo: null,
        email: null,
      },
      formExtrato: {
        idEmpresa: null,
        idUsuario: null,
      },
      formSaque: {
        id_empresa: null,
        idUsuario: null,
        valor: null,
      },
      dadosContaBancaria: {},
      valorTransacaoDebito: null,
      valorTransacaoCredito: null,
      abrirModalSaque: false,
      contaBancaria: null,
      dadosSaque: [],
      saldo: 0,
      abrirModalContaBancaria: false,
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
  },
  methods: {
    imprimir() {
      setTimeout(function () {
        window.print();
      }, 500);
    },
    alterarSomente1(item) {
      this.formaDeTransacao.forEach((element) => {
        if (element.id == item.id) {
          item.selecionado = true;
          this.formTransacao.formAplicacao = item.id;
        } else {
          element.selecionado = false;
        }
      });
    },
    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service
        .getAll('g', {}, `${model}/list/idEmpresa/idEmpresa=${this.idEmpresa}`)
        .then((res) => {
          res.data = decryptData(res.data);
          res.data.forEach((element) => {
            this[array].push({
              id: element[campoPK],
              label: element[campoDescricao],
              estado: element.estado,
              cidade: element.cidade,
            });
          });
        });
    },
    formataDataUTCAux(data) {
      return moment(data).utc().format('DD/MM/YYYY');
    },
    fecharModal() {
      this.abrirModalContaBancaria = false;
      this.buscaContasBancarias();
    },
    iniciarTransacao() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.formTransacao.tipoTransacao = 2;

          this.$vs.loading();

          service
            .post('transacao', 'iniciar-transacao', this.formTransacao)
            .then((res) => {
              console.log('Transacao Iniciada', res.data);
              this.modalTransacao = false;
              this.buscaDados();
              this.$vs.loading.close();
            })
            .catch((e) => {
              this.$vs.loading.close(e);
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: 'Transacao não pode ser iniciada',
                color: 'danger',
              });
            });
        }
      });
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    buscaContasBancarias() {
      service
        .post(
          'usuarios-contas-bancarias',
          'get-conta-bancaria',
          this.formTransacao,
        )
        .then((res) => {
          this.contaBancaria = res.data;
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.contaBancaria = [];
          this.$vs.loading.close(e);
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Nenhuma conta bancaria encontrada',
            color: 'danger',
          });
        });
    },
    buscaSaque() {
      service
        .post('saque', 'get-saques', this.formSaque)
        .then((res) => {
          res.data.forEach((element) => {
            if (element.debito == true) {
              element.valorDebito = element.valor;
              this.valorTransacaoDebito = element.valorDebito;
            }

            if (element.credito == true) {
              element.valorCredito = element.valor;
              this.valorTransacaoCredito = element.valor;
            }
          });

          this.saques = res.data;
          if (this.saques.length > 0) {
            this.$vs.loading.close();
          }
        })
        .catch((e) => {
          this.semSaque = true;
          this.$vs.loading.close(e);
          console.log(e);
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Não há transações para serem exibidas',
            color: 'danger',
          });
        });

      if (this.dados) {
        this.dados.forEach((element) => {
          this.contaBancaria = element;
        });
      }
    },
    openModalSaque(item, contaBancariaCriada) {
      console.log(item, contaBancariaCriada);
      if (this.contaBancaria.idContaBancaria) {
        this.dadosSaque[0] = this.contaBancaria;
        // if (this.contaBancaria.length > 0) {
        if (this.contaCorrenteTransacoes) {
          if (this.saldo) {
            this.dadosSaque[0].saldo = this.saldo;
          }
          // }
          this.dadosSaque[0].status = item;
          this.abrirModalSaque = true;
          // } else {
        }
      } else {
        if (this.contaBancariaCriada == true) {
          this.popupContaNova = false;
          this.abrirModalContaBancaria = true;
        } else {
          this.popupContaNova = true;
        }
      }
    },
    openModalMeusSaques(item, idSaque) {
      if (this.contaBancaria != 'OK') {
        this.dadosSaque[0] = this.contaBancaria;
      } else {
        this.dadosSaque[0] = [];
      }
      if (this.contaCorrenteTransacoes) {
        this.dadosSaque[0].saldo = this.contaCorrenteTransacoes[0].saldo;
      }
      this.dadosSaque[0].idSaque = idSaque;
      this.dadosSaque[0].status = item;
      this.abrirModalSaque = true;
    },
    formataData(data) {
      // formats data received from API
      var formattedData = moment(data).format('DD/MM/YYYY');
      return formattedData;
    },
    filtrar(por) {
      this.ultimoFiltro = por;
      if (por == 'Todos') this.itensFiltred = this.itens;
      if (por == 'Ativos')
        this.itensFiltred = this.itens.filter((x) => x.deletedAt == null);
      if (por == 'Inativos')
        this.itensFiltred = this.itens.filter((x) => x.deletedAt != null);
    },
    closeModais() {
      this.modalForm = false;
    },
    fecharModalSaque(contaBancaria) {
      if (contaBancaria.editar == true) {
        this.$vs.loading();
        setTimeout(() => {
          if (contaBancaria) {
            console.log(this.dadosContaBancaria, contaBancaria);
            this.dadosContaBancaria = contaBancaria;
          }
          this.abrirModalContaBancaria = true;
          this.$vs.loading.close();
        }, 300);
      }
      console.log('teste');
      this.abrirModalSaque = false;
      this.buscaDados();
      this.buscaSaque();
    },
    getDecoded() {
      const token = localStorage.getItem('user-token');
      if (token) {
        this.decoded = jwt.decode(token);
      }
      this.id_usuario = this.decoded.id_usuario;
      this.formExtrato.idUsuario = this.decoded.id_usuario;
      this.formExtrato.idEmpresa = this.decoded.id_empresa;
      this.formExtrato.email = this.decoded.email;
      this.formTransacao.tipo = this.decoded.tipo;
      this.formTransacao.idUsuario = this.decoded.id_usuario;
      this.formTransacao.email = this.decoded.email;
      this.formSaque.idUsuario = this.decoded.id_usuario;
      this.formSaque.id_empresa = this.decoded.id_empresa;
      this.idEmpresa = this.decoded.id_empresa;
    },
    makeFiltro() {
      this.buscaDados();
      // this.filtro = filtro;
    },
    buscaDados() {
      this.selected = [];
      this.$vs.loading();
      let objSend = {};
      if (this.filtro) {
        const getSelectDataId = (campo) => (campo ? campo.id : null);

        objSend = {
          ...this.filtro,
          status: getSelectDataId(this.filtro.tipoTransacao),
          dataInicial: this.filtro.dataInicial
            ? moment(this.filtro.dataInicial).format('YYYY-MM-DD')
            : null,
          dataFinal: this.filtro.dataFinal
            ? moment(this.filtro.dataFinal).format('YYYY-MM-DD')
            : null,
        };
      }

      objSend.tipo = this.decoded.tipo;
      objSend.idUsuario = this.decoded.id_usuario;
      objSend.email = this.decoded.email;
      objSend.formAplicacao = this.formTransacao.formAplicacao;

      console.log(objSend);

      service
        .post('extrato', 'list-extrato', objSend)
        .then((res) => {
          res.data.forEach((element) => {
            if (element.debito == true) {
              element.valorDebito = element.valor;
              this.valorTransacaoDebito = element.valorDebito;
            }

            if (element.credito == true) {
              element.valorCredito = element.valor;
              this.valorTransacaoCredito = element.valor;
            }

            this.saldo = element.saldo;

            console.log(this.saldo);
          });

          this.contaCorrenteTransacoes = res.data;
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.loading.close(e);
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Não foi possivel listar os extratos',
            color: 'danger',
          });
        });
    },
    opemModalInsertEdit() {
      this.modalTransacao = true;

      // this.modalForm = true;
    },
    opemModal(cod) {
      this.modalTransacao = true;
      this.modalSelecionado = [];
      // this.popupActive = true;
      var item = this.itens.find((x) => x.idCarteira == cod);
      Object.keys(item).forEach((element) => {
        if (
          element != 'createdAt' &&
          element != 'updatedAt' &&
          element != 'deletedAt' &&
          element.indexOf('id') != 0
        )
          this.modalSelecionado.push({
            coluna: element,
            [element]: item[element],
          });
      });
    },
    concluido() {
      this.buscaDados();
    },
    getStatusColor(data) {
      if (data != null) return 'success';
      return 'warning';
    },
    getStatusString(data) {
      if (data != null) return 'Finalizado';
      return 'Incompleto';
    },
  },
  created() {
    this.getDecoded();
    this.buscaDados();
    this.buscaContasBancarias();
    this.buscaSaque();
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>
<!------------ END SCRIPT ------------>

<!------------ START STYLE ------------>
<style lang="scss">
@media print {
  #content-area {
    margin-left: 0px;
  }
  .navbar-sticky .router-view .router-content {
    margin-top: 0px;
  }
  .vs-content-sidebar,
  .con-pagination-table,
  #data-list-list-view .vs-con-table .vs-table--header,
  .the-footer,
  .vs-navbar {
    display: none !important;
  }
  body,
  .vs-con-table .vs-con-tbody {
    background-color: #ffffff;
  }
  .vx-card,
  #data-list-list-view .vs-con-table .vs-table tr {
    box-shadow: none !important;
  }
  .td-check {
    visibility: hidden;
  }
}

.table {
  background: white;
}
.table-bordered {
  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: grey;
  width: 100%;
  tr td {
    padding: 2px;
  }
  tr:nth-child(2n) {
    background: #efefef !important;
  }
}
</style>
<style>
.con-vs-popup .vs-popup {
  width: 1000px !important;
}
.con-vs-popup .vs-popup {
  width: 600px !important;
}
.tabela {
  width: 100%;
}

.vx-card .vx-card__collapsible-content.vs-con-loading__container {
  overflow: auto;
}
.vx-card .vx-card__collapsible-content .vx-card__body {
  display: grid !important;
}
</style>
<!------------ END STYLE ------------>
